<aside class="app-rail" aria-label="Primary navigation">
  <nav class="rail-menu">
    @for (item of items(); track item.key) {
      <button
        class="rail-item"
        type="button"
        [class.active]="item.key === selectedKey()"
        [attr.aria-current]="item.key === selectedKey() ? 'page' : null"
        [attr.aria-label]="item.label"
        (click)="onSelectMenu(item.key)"
      >
        <span class="rail-item__icon" [class.rail-item__icon--has-badge]="getNotificationCount(item.key) > 0">
          <span class="material-icons">{{ item.icon }}</span>
          @if (getNotificationCount(item.key) > 0) {
            <span class="rail-item__badge" aria-label="{{ formatNotificationCount(getNotificationCount(item.key)) }} unread items">
              {{ formatNotificationCount(getNotificationCount(item.key)) }}
            </span>
          }
        </span>
        <span class="rail-item__label">{{ item.label }}</span>
      </button>
    }
  </nav>

  <footer class="rail-footer" aria-label="App version">
    <span class="rail-footer__label">v{{ appVersion() || '0.0.0' }}</span>
  </footer>
</aside>
